const {
  VITE_GOOGLE_ADS_ACCOUNT_CONVERSION_TAG,
  VITE_GOOGLE_ADS_PLUS_CONVERSION_TAG,
  VITE_GOOGLE_ADS_PREMIUM_CONVERSION_TAG,
  VITE_GOOGLE_ADS_NEWSLETTER_CONVERSION_TAG,
  VITE_GOOGLE_ADS_TYPEFORM_CONVERSION_TAG,
} = import.meta.env;

declare global {
  interface Window {
    gtag: (
      event: "event",
      conversion: GAdsConversionName,
      options: Record<string, unknown>,
    ) => void;
  }
}

type GAdsConversionType = "event";
type GAdsConversionName =
  | "conversion"
  | "newsletter-conversion"
  | "onboarding-conversion"
  | "plus-subscription-conversion"
  | "premium-subscription-conversion"
  | "registration-conversion";

type GTagId = string;
type GAdsConversionOptions = Record<string, unknown>;

const hasMarketingConsent = () => {
  const cookieYesConsent = window.getCkyConsent ? window.getCkyConsent() : null;
  const consentViaCookieYes =
    cookieYesConsent && cookieYesConsent.categories.advertisement;
  const noCmp = !window.getCkyConsent;

  return noCmp || consentViaCookieYes;
};

const gAdsConversionFactory =
  (
    type: GAdsConversionType,
    conversionName: GAdsConversionName,
    gTagId: GTagId,
  ) =>
  (options?: GAdsConversionOptions) => {
    if (!hasMarketingConsent()) {
      return;
    }

    if (!gTagId) {
      console.log("Conversion event not sent; missing id");
      return;
    }

    window.gtag(type, conversionName, {
      send_to: gTagId,
      ...options,
    });
  };

export const gAdsPlusSubscribeConversionEvent = gAdsConversionFactory(
  "event",
  "plus-subscription-conversion",
  VITE_GOOGLE_ADS_PLUS_CONVERSION_TAG,
);

export const gAdsPremiumSubscribeConversionEvent = gAdsConversionFactory(
  "event",
  "premium-subscription-conversion",
  VITE_GOOGLE_ADS_PREMIUM_CONVERSION_TAG,
);

export const gAdsOnboardingConversionEvent = gAdsConversionFactory(
  "event",
  "onboarding-conversion",
  VITE_GOOGLE_ADS_TYPEFORM_CONVERSION_TAG,
);

export const gAdsNewsletterConversionEvent = gAdsConversionFactory(
  "event",
  "newsletter-conversion",
  VITE_GOOGLE_ADS_NEWSLETTER_CONVERSION_TAG,
);

export const gAdsAccountConversionEvent = gAdsConversionFactory(
  "event",
  "registration-conversion",
  VITE_GOOGLE_ADS_ACCOUNT_CONVERSION_TAG,
);
